var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coverage_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B0BDC5",
    stopOpacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#coverage_svg__a)",
    d: "M18.49 6C11.56 6 5.54 7.5 2.42 10.48c-6.32 6.85 0 26.6 16.07 26.6s20.22-13.76 19.8-20.4C37.74 8.06 25.41 6 18.48 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 9.48l5.3 1.33-5.14 1.48a.76.76 0 00-.53.54l-1.3 5.19-1.56-5.44a.22.22 0 00-.16-.15l-5.49-1.38 5.56-1.6 1.4-5.61 1.52 5.25c.05.19.2.34.4.39m-9.17 7.18l2.12.53-2.05.59a.3.3 0 00-.21.22l-.52 2.07-.63-2.17a.09.09 0 00-.06-.06l-2.2-.55 2.22-.65.57-2.24.6 2.1c.02.08.09.14.16.16M27.74 3l2.82.72-2.74.78a.4.4 0 00-.28.3l-.7 2.76-.83-2.9a.12.12 0 00-.08-.08L23 3.85l2.96-.86.76-2.99.8 2.8c.03.1.11.18.22.2",
    fill: "#2196F3"
  }))));
}
export default SvgCoverage;